<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="sign-wrap" :style="{ height: height }">
      <div class="sign-login-wrap">
        <img class="login-logo" src="../../assets/login.png" alt="" />
        <h2>{{ $t("login.register") }}</h2>
        <el-input
          v-model="username"
          :placeholder="userEmailPlaceholder"
          type="username"
          @blur="usernameChange"
        ></el-input>

        <verify
          v-if="isShowPC"
          @slide-verify="verifyType"
          @updateVerifyCode="update"
          ref="verifychild"
        ></verify>
        <vertifyMoblie
          v-else
          @slide-verify="verifyType"
          @updateVerifyCode="update"
        ></vertifyMoblie>
        <div class="verTip">{{verifySuccessTip}}</div>
        <!-- <div class="verifyCodeWrap" v-if="isShowCode">
                  <el-input class="password" v-model="verifyCode" :placeholder="verifyCodePlaceholder" @input="verifyCodeChange"></el-input>
                  <span v-show="show" @click="getCode">{{$t('login.getCode')}}</span>
                  <span v-show="!show" class="count">{{count}}s</span>
              </div> -->
        <!-- <el-input v-if="isShowCode" class="password" v-model="password" type="password" :placeholder="passwordPlaceholder" @input="passwordChange"></el-input> -->
        <!-- <div v-if="isLogin" class="login-btn act" @click="registerBtn">{{$t('login.register')}}</div>
              <div v-else class="login-btn">{{$t('login.register')}}</div> -->
        <div class="login-sub">
          <el-checkbox v-model="checked">{{ $t("login.read") }}</el-checkbox>
          <span @click="policy" class="login-policy">{{
            $t("login.policy")
          }}</span>
        </div>
        <div class="login-botton">
          <span class="login-register-btn" @click="toPath('smsLogin')">{{
            $t("login.messageLogin")
          }}</span>
          <span class="login-register-btn" @click="toPath('login')">{{
            $t("login.already")
          }}</span>
        </div>
      </div>
    </div>
    <div class="privacyWrap" v-if="isSHowPrivacy">
      <div class="privacy">
        <div class="privacyClose">
          <i class="el-icon-close" @click="closePrivacy"></i>
        </div>
        <div class="privacyContent">
          <privacyH5 :http="https"></privacyH5>
        </div>
      </div>
    </div>
     <div class="confirmLayercovering" id="confirmLayercovering" v-if="isSHowPrivacyTip">
      <div class="confirmLayer" id="confirmLayer">
        <p class="confirmTit" id="confirmTit">{{ $t("login.repaceCode") }}
          <div class="confirmbtns">
            <a class="confirmClose" id="confirmClose" @click="cancel()">{{ $t("login.cancel") }}</a>
            <a class="confirmSure" id="confirmSure" @click="toPath('login')">{{ $t("login.sure") }}</a>
          </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import privacyH5 from "./components/privacyH5.vue";
import verify from "./components/verifyPc.vue";
import vertifyMoblie from "./components/vertifyMoblie.vue";
import { geteCode, getpCode, getRegister,emailLogin} from "@/api/api";
export default {
  components: { top, bottom, privacyH5, verify, vertifyMoblie },
  name: "home",
  data() {
    return {
      height: "",
      username: "",
      password: "",
      isLogin: false,
      checked: true,
      verifyCode: "",
      isShowCode: false,
      show: true,
      showVerify: true,
      count: "",
      timer: null,
      langSet: "",
      usernamePlaceholder: "",
      passwordPlaceholder: "",
      userEmailPlaceholder: "",
      verifyCodePlaceholder: "",
      isShowPC: true,
      https: "",
      isSHowPrivacy: false,
      verifySuccessTip:'',
      isSHowPrivacyTip:false,
      repaceCode:''
    };
  },
  created() {},
  mounted() {
    console.log(localStorage.getItem("source"));
    this.langSet = localStorage.getItem("languageSet") || "zh";
    this.usernamePlaceholder = this.$t("login.username");
    this.userEmailPlaceholder = this.$t("login.userEmail");
    this.passwordPlaceholder = this.$t("login.password");
    this.verifyCodePlaceholder = this.$t("login.verifiyCode");
    this.setHeight();
    this.isMobile();
  },
  methods: {
    cancel(){
        this.isSHowPrivacyTip = false
    },
    sure(){
        this.$router.push({ path: "/" });
    },
    policy() {
      this.isSHowPrivacy = true;
      this.https = this.$Url + "api.php?m=h5&mid=53&f=content&id=2";
    },
    closePrivacy() {
      this.isSHowPrivacy = false;
      this.https = "";
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        this.isShowPC = false;
      } else {
        this.isShowPC = true;
      }
    },
    setHeight() {
      this.height = window.innerHeight - 145 + "px";
    },
    toPath(name) {
      this.$router.push({
        name,
      });
    },
    usernameChange() {
      console.log(this.username);
      // const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      const regEmail =/^[a-zA-Z0-9_-](([a-zA-Z0-9_-]|(\.[a-zA-Z0-9_-])){0,30})@[a-zA-Z0-9_-]+(\.[a-zA-Z]+){1,2}$/;
      // const regMobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      let isEmail = regEmail.test(this.username);
      // let isMobile = regMobile.test(this.username);
      console.log(isEmail)
      if (!isEmail) {
        var mes="请正确输入邮箱地址";
        if(this.langSet=='en'){
          mes="Please enter the correct email address"
        }
        this.$message({
          message: mes,
          center: true,
        });
      } else {
        // this.showVerify = false
      }
      // if(this.username.length > 0 && this.password.length > 0 && this.verifyCode.length > 0 && this.isShowCode == true){
      //   this.isLogin = true;
      // }else{
      //   this.isLogin = false;
      // }
      // if(this.username.length > 0 && this.password.length > 0){
      //   this.isLogin = true;
      // }else{
      //   this.isLogin = false;
      // }
    },
    passwordChange(e) {
      this.password = e;
      // if(e.length > 0 && this.username.length > 0 && this.verifyCode.length > 0 && this.isShowCode == true){
      //   this.isLogin = true;
      // }else{
      //   this.isLogin = false;
      // }
      if (e.length > 0 && this.username.length > 0) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    },
    verifyCodeChange(e) {
      this.verifyCode = e;
      if (
        e.length > 0 &&
        this.username.length > 0 &&
        this.password.length > 0 &&
        this.isShowCode == true
      ) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
      if (this.username.length > 0) {
        // const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        // const regMobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        // if(regEmail.test(this.username)){
        //   let data = this.$qs.stringify({
        //     email: this.username
        //   })
        //   geteCode(data).then(res=>{
        //     console.log(res)
        //   }).catch(err=>{
        //     console.log(err)
        //   })
        // }else if(regMobile.test(this.username)){
        //   let data = this.$qs.stringify({
        //     mobile: this.username,
        //   })
        //   getpCode(data).then(res=>{
        //     console.log(res)
        //   }).catch(err=>{
        //     console.log(err)
        //   })
        // }else{
        //   this.$message({
        //     message: '请正确输入邮箱地址/手机号',
        //     center: true
        //   });
        // }
      }
    },
    update() {
      // console.log(111)
    },
    verifyType() {
      let forget =   this.$route.query.forget;
      console.log(forget)
      const regEmail = /^[a-zA-Z0-9_-](([a-zA-Z0-9_-]|(\.[a-zA-Z0-9_-])){0,30})@[a-zA-Z0-9_-]+(\.[a-zA-Z]+){1,2}$/;
      const regMobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (regEmail.test(this.username)) {
      console.log(this.username)
      var source=''
      if(localStorage.getItem("source")){
        source=localStorage.getItem("source");
      }
       let data = this.$qs.stringify({
            email: this.username,
            forget:forget,
            source:source
          })
        emailLogin(data)
          .then((res) => {
            console.log(res);
            if(res.data.errno == 0){
              if(this.langSet=='zh'){
                this.verifySuccessTip=res.data.errmsg
              }else{
                this.verifySuccessTip='The verification link has been sent to your email, please go to the mailbox to verify'
              }
              
            }else if(res.data.errno == 3){
                this.isSHowPrivacyTip = true;
                //  this.repaceCode = res.data.errmsg;
     
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        // this.$message({
        //   message: "请正确输入邮箱地址/手机号",
        //   center: true,
        // });
        var mes="请正确输入邮箱地址";
        if(this.langSet=='en'){
          mes="Please enter the correct email address"
        }
        this.$alert(mes, {
          confirmButtonText: '确定',
          callback: action => {
            location.reload();
          }
        });
      }
      // this.isShowCode = data;
    },
    registerBtn() {
      // const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      // const regMobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      var source=''
      if(localStorage.getItem("source")){
        source=localStorage.getItem("source");
      }
      if (this.username.length > 0) {
        if (this.username.indexOf("@") >= 0) {
          let data = this.$qs.stringify({
            email: this.username,
            t: "ems",
            smsCode: "940418",
            password: this.password,
            source:source
          });
          getRegister(data)
            .then((res) => {
              console.log(res);
              if (res.data.errno == 0) {
                this.$store.dispatch("userLogin", true);
                localStorage.setItem("Flag", "isLogin");
                localStorage.setItem("memberid", res.data.rst.memberid);
                localStorage.setItem("uuid", res.data.rst.uuid);
                this.$router.push({ path: "/pair" });
              } else {
                this.$message(res.data.errmsg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          let data = this.$qs.stringify({
            mobile: this.username,
            t: "sms",
            smsCode: "940418",
            password: this.password,
            source:source
          });
          getRegister(data)
            .then((res) => {
              console.log(res);
              if (res.data.errno == 0) {
                this.$store.dispatch("userLogin", true);
                localStorage.setItem("Flag", "isLogin");
                localStorage.setItem("memberid", res.data.rst.memberid);
                localStorage.setItem("uuid", res.data.rst.uuid);
                this.$router.push({ path: "/pair" });
              } else {
                this.$message(res.data.errmsg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        if (this.langSet == "zh") {
          this.$message({
            message: "请输入邮箱地址/手机号",
            center: true,
          });
        } else {
          this.$message({
            message: "Please enter email address/mobile number",
            center: true,
          });
        }
      }
      // if(regEmail.test(this.username)){
      //   let data = this.$qs.stringify({
      //     email: this.username,
      //     t: 'ems',
      //     smsCode: this.verifyCode,
      //     password: this.password
      //   })
      //   getRegister(data).then(res=>{
      //     console.log(res)
      //     if(res.data.errno == 0){
      //       this.$store.dispatch("userLogin", true);
      //       localStorage.setItem("Flag", "isLogin")
      //       localStorage.setItem("memberid", res.data.rst.memberid)
      //       localStorage.setItem("uuid", res.data.rst.uuid)
      //       this.$router.push({path: '/'});
      //     }else{
      //       this.$message(res.data.errmsg);
      //     }
      //   }).catch(err=>{
      //     console.log(err)
      //   })
      // }else if(regMobile.test(this.username)){
      //   let data = this.$qs.stringify({
      //     mobile: this.username,
      //     t: 'sms',
      //     smsCode: this.verifyCode,
      //     password: this.password
      //   })
      //   getRegister(data).then(res=>{
      //     console.log(res)
      //     if(res.data.errno == 0){
      //       this.$store.dispatch("userLogin", true);
      //       localStorage.setItem("Flag", "isLogin")
      //       localStorage.setItem("memberid", res.data.rst.memberid)
      //       localStorage.setItem("uuid", res.data.rst.uuid)
      //       this.$router.push({path: '/'});
      //     }else{
      //       this.$message(res.data.errmsg);
      //     }
      //   }).catch(err=>{
      //     console.log(err)
      //   })
      // }
    },
  },
};
</script>

<style lang="scss">
/* 确认弹框 start */
  .confirmLayercovering {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1005;
    background-color: rgba(0, 0, 0, .5);
    // display: none;
    font-size: 0;
  }

  .confirmLayer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
   width: 400px;
    height: 205px;
    background: #fff;
    border-radius: 10px;
    padding: .1rem;
    box-sizing: border-box;
    // display: none;
  }

  .confirmTit {
   text-align: center;
    width: 100%;
        height: 140px;
    line-height: 4;
    color: #333;
    font-size: 20px;
    line-height: 140px;
  }

  .confirmbtns {
    width: 100%;
    height: 30%;
    display: flex;
  }

  .confirmbtns a {
   display: inline-block;
    flex: 1;
    height: 100%;
    line-height: 3.5;
    border-radius: 4px;
    font-size: 18px;
    text-align: center;
  }

  .confirmClose {
    background-color: #bbb;
    color: #fff;
    margin-right: .1rem;
  }

  .confirmSure {
    background: #ff7035;
    color: #fff;
  }
.verTip{
    color:red;
    font-size: 18px;
    margin-bottom: 28px;
    text-align: center;
}
.sign-wrap {
  width: 100%;
  background: url(../../assets/signbg.jpg) no-repeat;
  background-size: 100% 100%;
}
.sign-login-wrap {
  width: 600px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 30px 35px 59px;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.sign-login-wrap h2 {
  font-size: 30px;
  line-height: 42px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 35px;
}
.sign-login-wrap .password .el-input__inner {
  height: 50px;
  line-height: 50px;
}
.sign-login-wrap .el-input__inner {
  width: 100%;
  height: 60px;
  background: rgba(244, 244, 244, 1);
  border: 1px solid rgba(218, 218, 218, 1);
  margin-bottom: 20px;
  border-radius: 0;
  font-size: 20px;
  padding-left: 40px;
}
.sign-login-wrap .login-btn {
  width: 100%;
  height: 60px;
  background: rgba(244, 244, 244, 1);
  border: 1px solid rgba(218, 218, 218, 1);
  margin-bottom: 20px;
  border-radius: 0;
  font-size: 20px;
  color: #999;
  text-align: center;
  line-height: 60px;
}
.sign-login-wrap .login-btn.act {
  cursor: pointer;
  background: #9B8B1C;
  border-color: #9B8B1C;
  color: #fff;
}
.login-sub {
  margin-bottom: 32px;
  text-align: center;
}
.login-sub .el-checkbox__input.is-checked + .el-checkbox__label {
  font-size: 18px;
  color: #666;
}
.login-sub .login-policy {
  font-size: 18px;
  color: #037aff;
  cursor: pointer;
}
.login-sub .el-checkbox__label {
  font-size: 18px;
}
.login-sub .el-checkbox__inner {
  position: relative;
  top: -2px;
}
.login-logo {
  width: 165px;
  margin: 0 auto 20px;
  display: block;
}
.login-botton {
  text-align: center;
  font-size: 20px;
  color: #585858;
}
.login-botton span {
  cursor: pointer;
}
.login-botton .login-register-btn {
  color: #2d90ff;
  margin-left: 30px;
}
.verifyCodeWrap {
  display: flex;
  justify-content: space-between;
}
.verifyCodeWrap span {
  flex: 1;
  margin-left: 20px;
  height: 50px;
  line-height: 50px;
  background: rgba(244, 244, 244, 1);
  text-align: center;
  cursor: pointer;
}
.verifyCodeWrap .el-input {
  width: 70%;
}
.privacyWrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);

  .privacy {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 60%;
    overflow: hidden;
    background: #fff;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    .el-icon-close {
      font-size: 30px;
      cursor: pointer;
      margin: 10px;
    }
    .privacyContent {
      padding: 0 15px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .sign-login-wrap {
    width: 95%;
    padding: 0.5rem;
  }
  .login-sub .login-policy,
  .login-sub .el-checkbox__input.is-checked + .el-checkbox__label,
  .verifyCodeWrap span {
    font-size: 14px;
  }
  .privacyWrap .privacy {
    width: 85%;
    border-radius: 10px;
  }
  .el-icon-close {
    font-size: 20px;
    margin: 0.2rem;
  }
}
</style>